<div class="filter-panel padded-top">
  <div class="filter-panel-item">
    <mat-form-field>
      <mat-label>{{ "choose-municipality" | translate }}</mat-label>
      <mat-select [formControl]="municipalityForm" multiple (selectionChange)="onSelectedMunicipalities($event)">
        <mat-option [value]="defaultGuid" (onSelectionChange)="selectAllMunicipalities(!selectedAllMunicipalities)">
          {{ 'all-municipalities' | translate }}
        </mat-option>
        <mat-option *ngFor="let municipality of municipalities" [value]="municipality.id">
          {{ language == 'en' ? municipality.name : municipality.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="filter-panel-item">
    <mat-form-field>
      <mat-label>{{ "choose-period" | translate }}</mat-label>
      <mat-select [formControl]="periodForm" multiple (selectionChange)="onSelectedPeriods($event)">
        <mat-option [value]="defaultGuid" (onSelectionChange)="selectAllPeriods(!selectedAllPeriods)">
          {{ 'all-periods' | translate }}</mat-option>
        <mat-option *ngFor="let period of periods" [value]="period.id">
          {{ language == 'en' ? period.name : period.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="filter-panel-item" *ngIf="{ streetRecommendations: streetRecommendations$ | async } as model">
    <mat-form-field class="example-full-width">
      <input type="text" [placeholder]="'choose-street' | translate" matInput [formControl]="streetForm"
        [matAutocomplete]="auto" />
      <mat-icon color="primary" matSuffix *ngIf="streetForm.value && streetForm.value.length > 0"
        (click)="streetForm.setValue('')"></mat-icon>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of streetRecommendations" [value]="option">
          {{ option }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="filter-panel-item">
    <mat-form-field>
      <mat-label>{{ "choose-management" | translate }}</mat-label>
      <mat-select multiple [formControl]="managementForm" (selectionChange)="onSelectedManagement($event)">
        <mat-option *ngFor="let type of buildingManagementTypeEnumValues" [value]="buildingManagementTypes[type]">
          {{ getTypeDescription(buildingManagementTypes[type]) }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="filter-panel-item">
    <button mat-raised-button color="primary" mat-raised-button (click)="filterBuildings()">
      <mat-icon>search</mat-icon>
      {{ "search" | translate }}
    </button>
  </div>

  <div class="filter-panel-item margin-right">
    <button *ngIf="isAdministrator" (click)="addBuilding()" color="primary" mat-raised-button>
      <mat-icon>add</mat-icon> {{ "add" | translate }}
    </button>
    <button *ngIf="isAdministrator" (click)="fileInput.click()" color="primary" mat-raised-button>
      <mat-icon>import_export</mat-icon> {{ "import" | translate }}
    </button>
    <button (click)="exportBuildings()" color="primary" mat-raised-button>
      <mat-icon>import_export</mat-icon> {{ "export" | translate }}
    </button>
    <input #fileInput type="file" [accept]="setAcceptFiles()" class="hidden" (change)="onFileChange($event)" />
  </div>
</div>

<table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <mat-icon *ngIf="element !== expandedElement">expand_more</mat-icon>
      <mat-icon *ngIf="element === expandedElement">expand_less</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="street">
    <th mat-header-cell *matHeaderCellDef>{{ "street" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <b>{{ element.street }} {{ element.streetNumber }}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="construction">
    <th class="text-center" mat-header-cell *matHeaderCellDef>
      {{ "year-of-building" | translate }}
    </th>
    <td class="text-center" mat-cell *matCellDef="let element">
      {{ getYear(element.construction) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="municipality">
    <th mat-header-cell class="text-center" *matHeaderCellDef>
      {{ "municipality" | translate }}
    </th>
    <td mat-cell class="text-center" *matCellDef="let element">
      {{ element.municipality.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="city">
    <th mat-header-cell class="text-center" *matHeaderCellDef>
      {{ "city" | translate }}
    </th>
    <td mat-cell class="text-center" *matCellDef="let element">
      {{ element.municipality.city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="actions-panel">
        <mat-icon (click)="goToDetails(element)" matTooltip="Details">info</mat-icon>
        <mat-icon *ngIf="isAdministrator" (click)="editBuilding($event, element)" matTooltip="Edit">edit</mat-icon>
        <mat-icon *ngIf="isAdministrator" (click)="deleteBuilding($event, element)" matTooltip="Delete">delete
        </mat-icon>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
      <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        <div class="expand-panel" *ngIf="element == expandedElement">
          <app-manage-building [validCategories]="validCategories" [type]="manageBuildingTypes.Update"
            [modelId]="element.id"></app-manage-building>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element; onExpand()"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>

<mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  (page)="changePage($event)" showFirstLastButtons>
</mat-paginator>
